module.exports = __webpack_public_path__ + "412feb45f0c872a13309a746b1df9956.svg";